import {t} from "../../../../../../services/i18n";
import FoldableSettingSection from "../../../../../common/FoldableSettingSection";
import PersonalDetails from "./PersonalDetails";
import CustomSwitch from "../../../../../common/CustomSwitch";
import React, {useEffect, useState} from "react";
import {HStack, VStack} from "native-base";
import AppText from "../../../../../common/AppText";
import InfoTooltip from "../../../../../common/InfoTooltip";
import {Colors} from "../../../../../../styles/Colors";
import {GlobalStyleAttributes} from "../../../../../../styles/GlobalStyles";
import {isMobile} from "../../../../../../services/Helpers";
import {Segmented} from "antd";
import FormInput from "../../../../../common/FormInput";
import AdvanceSelect from "../../../../../common/AdvanceSelect";
import {USERS_SELECT, HEAD_TYPES} from "../../../../../../services/ConstHelper";

const GroupDetails = (props) => {
    const {errors, touched, setFieldValue, setTouched, values, initialValues, validationSchema} = props
    const headType = values.headType ?? HEAD_TYPES.NEW
    const [headDetailsIsOpen, setHeadDetailsIsOpen] = useState(true)
    const [childDetailsIsOpen, setChildDetailsIsOpen] = useState(false)
    const [selectedHeadUser, setSelectedHeadUser] = useState(null)

    useEffect(() => {
        setTouched({})
    }, [])

    useEffect(() => {
        setSelectedHeadUser(null)
        if (headType === HEAD_TYPES.EXISTING) {
            setFieldValue('parent', {})
            setChildDetailsIsOpen(true)
        } else {
            setFieldValue('parent', initialValues.parent)
        }
    }, [headType])

    const handleExistingHeadChange = (user) => {
        setSelectedHeadUser(user)
        setFieldValue('parent', user ? { id: user.user_fk } : {})
    }

    const parentCond = validationSchema?.fields?.parent;
    const parentSchema = parentCond?.resolve
        ? parentCond.resolve({ parent: values, value: values.parent, context: values })
        : parentCond;

    const handleChildChange = (field) => (value) => {
        setFieldValue(`child.${field}`, value)
    }

    const handleParentChange = (field) => (value) => {
        setFieldValue(`parent.${field}`, value)
    }

    return (
        <VStack space={'1.5rem'}>
            <HStack alignItems={'center'}>
                <HStack space={'0.5rem'} alignItems={'center'}>
                    <CustomSwitch isChecked={values.isChildRegistration} onToggle={(val) => setFieldValue('isChildRegistration', val)} />
                    <AppText>{t(values.isChildRegistration ? 'with-head' : 'without-head')}</AppText>
                </HStack>
                <InfoTooltip title={t('toggle-head-info')}/>
            </HStack>
            {values.isChildRegistration ?
                <>
                    <div style={{width: 'auto'}}>
                        <Segmented
                            value={headType}
                            options={[
                                { label: t('head-type-new'), value: HEAD_TYPES.NEW },
                                { label: t('head-type-existing'), value: HEAD_TYPES.EXISTING },
                            ]}
                            onChange={(val) => setFieldValue('headType', val)}
                        />
                    </div>
                    {headType === HEAD_TYPES.EXISTING ? (
                        <FormInput
                            required
                            width={isMobile ? "100%" : "50%"}
                            error={touched.parent && (errors.parent?.id || errors.parent)}
                            containerProps={{mb: '0'}}
                        >
                            <AdvanceSelect
                                type={USERS_SELECT}
                                initValue={selectedHeadUser}
                                onChange={handleExistingHeadChange}
                                hideLeadType
                                hideFreefitType
                                hideCustomerId
                                allowInactive
                                isClearable
                                hideGroupDependents
                                showGroupStatus
                                placeholder={t('group-head-search-placeholder')}
                                isError={touched.parent && (errors.parent?.id || errors.parent)}
                            />
                        </FormInput>
                    ) : (
                        <FoldableSettingSection
                            header={isMobile ? t('group-head') : t('group-head') + ' - ' + values.parent.first_name + ' ' + values.parent.last_name}
                            isOpen={headDetailsIsOpen}
                            onToggle={() => setHeadDetailsIsOpen(!headDetailsIsOpen)}
                            errorIcon={errors.parent && touched.parent}
                        >
                            <PersonalDetails
                                values={values.parent}
                                errors={errors.parent || {}}
                                touched={touched.parent || {}}
                                validationSchema={parentSchema}
                                setFieldValue={(field, value) => setFieldValue(`parent.${field}`, value)}
                                handleChange={handleParentChange}
                            />
                        </FoldableSettingSection>
                    )}
                    <FoldableSettingSection
                        header={isMobile ?  t(`group-child`) : t(`group-child`) + ' - ' + values.child.first_name + ' ' + values.child.last_name}
                        isOpen={childDetailsIsOpen}
                        onToggle={() => setChildDetailsIsOpen(!childDetailsIsOpen)}
                        errorIcon={errors.child && touched.child}
                    >
                        <PersonalDetails values={values.child} errors={errors.child || {}} touched={touched.child || {}} validationSchema={validationSchema?.fields.child} setFieldValue={(field, value) => setFieldValue(`child.${field}`, value)} handleChange={handleChildChange} isChild={true}/>
                    </FoldableSettingSection>
                </> :
                <VStack p={'1rem'} space={'0.5rem'} borderWidth={1} borderColor={Colors.borderColor} borderRadius={4} opacity={1}>
                    <HStack alignItems={'center'}>
                        <AppText fontSize={GlobalStyleAttributes.fonts.heading3} boldFont>{t(`group-child-without-head`)}</AppText>
                        <InfoTooltip title={t('group-child-tooltip-without-head')}/>
                    </HStack>
                    <PersonalDetails values={values.child} errors={errors.child || {}} touched={touched.child || {}} validationSchema={validationSchema?.fields.child} setFieldValue={(field, value) => setFieldValue(`child.${field}`, value)} handleChange={handleChildChange} isChild={true}/>
                </VStack>

                }
        </VStack>

    )
}

export default GroupDetails